export var FeedbackTypes;
(function (FeedbackTypes) {
    FeedbackTypes["Question"] = "question";
    FeedbackTypes["Edit"] = "edit";
    FeedbackTypes["QuestionWithEdit"] = "question-with-edit";
})(FeedbackTypes || (FeedbackTypes = {}));
//# sourceMappingURL=feedback.types.js.map